// Blush Collection
import Blush1 from "../images/men/Blush1.png";
import Blush2 from "../images/men/Blush2.png";
import Blus3 from "../images/men/Blus3.png";

// Divine Collection
import Divine1 from "../images/men/Divine1.png";
import Divine2 from "../images/men/Divine2.png";
import Divine3 from "../images/men/Divine3.png";

// Ivory Gold Ethnic Collection
import IvoryGoldEthnic1 from "../images/men/IvoryGoldEthnic1.png";
import IvoryGoldEthnic2 from "../images/men/IvoryGoldEthnic2.png";
import IvoryGoldEthnic3 from "../images/men/IvoryGoldEthnic3.png";
import IvoryGoldEthnic4 from "../images/men/IvoryGoldEthnic4.png";

// Lavender Kurta Collection
import LavenderKurta1 from "../images/men/LavenderKurta1.png";
import LavenderKurta2 from "../images/men/LavenderKurta2.png";
import LavenderKurta3 from "../images/men/LavenderKurta3.png";
import LavenderKurta4 from "../images/men/LavenderKurta4.png";
import LavenderKurta5 from "../images/men/LavenderKurta5.png";

// Midnight Gold Collection
import MidnightGold1 from "../images/men/MidnightGold1.png";
import MidnightGold2 from "../images/men/MidnightGold2.png";
import MidnightGold3 from "../images/men/MidnightGold3.png";

// Mirror Work Collection
import MirrorWork1 from "../images/men/MirrorWork1.png";
import MirrorWork2 from "../images/men/MirrorWork2.png";
import MirrorWork3 from "../images/men/MirrorWork3.png";

// Onyx Sequin Collection
import OnyxSequin1 from "../images/men/OnyxSequin1.png";
import OnyxSequin2 from "../images/men/OnyxSequin2.png";
import OnyxSequin3 from "../images/men/OnyxSequin3.png";
import OnyxSequin4 from "../images/men/OnyxSequin4.png";

// Purple Collection
import purple1 from "../images/men/purple1.png";
import purple2 from "../images/men/purple2.png";
import purple3 from "../images/men/purple3.png";
import purple4 from "../images/men/purple4.png";

// Red Printed Kurta Collection
import redPrintedKurta1 from "../images/men/redPrintedKurta1.png";
import redPrintedKurta2 from "../images/men/redPrintedKurta2.png";
import redPrintedKurta3 from "../images/men/redPrintedKurta3.png";
import redPrintedKurta4 from "../images/men/redPrintedKurta4.png";
import redPrintedKurta5 from "../images/men/redPrintedKurta5.png";

// Royal Blue Bandhani Collection
import RoyalBlueBandhani1 from "../images/men/RoyalBlueBandhani1.png";
import RoyalBlueBandhani2 from "../images/men/RoyalBlueBandhani2.png";
import RoyalBlueBandhani3 from "../images/men/RoyalBlueBandhani3.png";
import RoyalBlueBandhani4 from "../images/men/RoyalBlueBandhani4.png";

// Tuxedo Suit Collection
import TuxedoSuit1 from "../images/men/TuxedoSuit1.png";
import TuxedoSuit2 from "../images/men/TuxedoSuit2.png";
import TuxedoSuit3 from "../images/men/TuxedoSuit3.png";
import TuxedoSuit4 from "../images/men/TuxedoSuit4.png";

export const mensCollection = [
  {
    id: "m1",
    title: "Lavender Elegance",
    price: "$88",
    defaultImage: LavenderKurta1,
    allImages: [
      LavenderKurta1,
      LavenderKurta2,
      LavenderKurta3,
      LavenderKurta4,
      LavenderKurta5,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "This sophisticated lavender kurta embodies elegance and comfort, perfect for both casual and formal occasions. The soft lavender hue exudes calmness and refinement.",
      },
    ],
  },
  {
    id: "m2",
    title: "Royal Blue Bandhani",
    price: "$78",
    defaultImage: RoyalBlueBandhani1,
    allImages: [
      RoyalBlueBandhani1,
      RoyalBlueBandhani2,
      RoyalBlueBandhani3,
      RoyalBlueBandhani4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Made from a high-quality crepe-silk blend, the fabric offers a fluid drape and a soft touch against the skin, ensuring you stay comfortable during long wedding rituals or festive gatherings.",
      },
      {
        title: "Description",
        description:
          "The kurta features a timeless Bandhani (tie-dye) inspired print with delicate silver foil accents that shimmer under evening lights. The intricate borders on the cuffs and hem add a regal touch to the overall look. A highlight of this set is the matching indigo blue stole, embellished with a meticulously crafted mirror-work border (sheesha work), elevating the ensemble to a premium festive status. A sharp, tailored fit with a contemporary V-neckline that gives a lean, elongated appearance. Pair this vibrant blue piece with the included cream-colored dhoti pants or churidars and leather kolhapuris for a sophisticated, high-fashion ethnic look.",
      },
    ],
  },
  {
    id: "m3",
    title: "Midnight Gold",
    price: "$88",
    defaultImage: MidnightGold1,
    allImages: [MidnightGold1, MidnightGold2, MidnightGold3],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Crafted from a premium heavy-weight velvet or dark silk blend, the fabric provides a structured drape and a subtle, high-end sheen. The texture is rich to the touch, making it perfect for cold-weather celebrations.",
      },
      {
        title: "Description",
        description:
          "The garment features an all-over Baroque-inspired scroll pattern. The intricate embroidery uses antique gold thread that creates a beautiful contrast against the midnight black fabric, giving it a three-dimensional depth. A classic knee-length cut with a sleek mandarin collar and a concealed front placket to keep the focus on the embroidery. The dupatta is a solid black georgette or silk stole featuring a delicate metallic gold border (Gota Patti work) that frames the torso elegantly. Paired with coordinated black Aligarh-style trousers or slim-fit chinos for a streamlined, modern look. A symphony of midnight black and antique gold. This ensemble is designed for the man who commands the room with understated power.",
      },
    ],
  },
  {
    id: "m4",
    title: "Tuxedo Suit",
    price: "$138",
    defaultImage: TuxedoSuit1,
    allImages: [TuxedoSuit1, TuxedoSuit2, TuxedoSuit3, TuxedoSuit4],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Crafted from a premium textured blend, the fabric is designed to catch the light with every move, offering a subtle cross-hatch pattern that adds depth and a rich, multi-dimensional feel. Engineered with a slim-fit cut, the jacket features structured shoulders and a tapered waist to enhance the masculine frame, while the trousers are flat-fronted for a clean, contemporary line.",
      },
      {
        title: "Description",
        description:
          "This two-piece tuxedo features a high-sheen metallic finish in a deep midnight blue, accented by a luxurious satin shawl lapel that creates a bold, red-carpet look. The jacket is equipped with a refined single-button closure covered in matching satin, sleek jetted pockets, and four-button cuffs for a tailored, high-end finish. For a modern 'cocktail formal' look, pair it with a crisp white crew neck (as shown) and tan leather loafers, or elevate it for a black-tie event with a pleated tuxedo shirt and a velvet bow tie. A masterclass in evening elegance. Whether it's a high-profile gala or a celebratory reception, this suit ensures you stand out with effortless style and prestige.",
      },
    ],
  },
  {
    id: "m5",
    title: "Ivory Gold Ethnic",
    price: "$95",
    defaultImage: IvoryGoldEthnic1,
    allImages: [
      IvoryGoldEthnic1,
      IvoryGoldEthnic2,
      IvoryGoldEthnic3,
      IvoryGoldEthnic4,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Crafted from premium Cotton-Silk, this set offers the structured look of silk with the breathability of cotton. The fabric has a natural luster that radiates elegance without being overpowering. A tailored, straight-fit kurta that hits just above the knee, designed to provide a sharp, regal frame while allowing for ease of movement.",
      },
      {
        title: "Description",
        description:
          "The kurta is adorned with a sophisticated gold foil geometric print in a diamond motif. The look is elevated by a matching ivory stole (dupatta) featuring a thick, intricately woven Zari border that adds weight and opulence to the silhouette. The kurta features classic potli buttons along the placket and a crisp mandarin collar. It is paired with traditional dhoti-style pants that feature a matching gold border, creating a cohesive, high-fashion look. Timeless, regal, and impeccably crafted. This ivory set captures the essence of traditional royalty with a clean, modern aesthetic.",
      },
    ],
  },
  {
    id: "m6",
    title: "Mirror Work Magnificence",
    price: "$85",
    defaultImage: MirrorWork1,
    allImages: [MirrorWork1, MirrorWork2, MirrorWork3],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Set against a premium ivory fabric, the mirrors are meticulously stitched to ensure both durability and a luxurious, weighted feel. The ensemble includes a long, lightweight crinkled cotton dupatta with a soft fringe, providing a delicate contrast to the structured, shimmering kurta. It is paired with voluminous white Patiala-style dhoti pants that offer a relaxed yet regal fit, allowing for maximum comfort during long celebrations.",
      },
      {
        title: "Description",
        description:
          "The kurta is a labor of love, featuring dense, all-over Abha mirror-work (Shisha embroidery) that creates a mesmerizing reflective surface. This set is the definitive choice for Sangeet ceremonies, high-energy wedding receptions, or festive night events where making a grand entrance is the priority.",
      },
    ],
  },
  {
    id: "m7",
    title: "Onyx Sequin",
    price: "$92",
    defaultImage: OnyxSequin1,
    allImages: [OnyxSequin1, OnyxSequin2, OnyxSequin3, OnyxSequin4],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL", "XXL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "The base is a premium velvet-feel fabric, heavily embellished with densely packed sequins to provide a rich, tactile experience and a luxurious weight. Cut in a modern slim fit, the jacket offers a sharp shoulder profile and a tapered waist, ensuring a clean and powerful silhouette.",
      },
      {
        title: "Description",
        description:
          "This jacket features a striking vertical 'raindrop' pattern of shimmering black sequins that catch the light from every angle. It is contrasted by a smooth, matte satin shawl lapel for a balanced, sophisticated aesthetic. The tuxedo is finished with a single-button closure and sleek, piped jetted pockets that maintain a streamlined look. It is paired with a white pleated tuxedo shirt to heighten the formal contrast. While traditionally paired with formal trousers and dress shoes, it can be styled with premium white sneakers (as shown) for a contemporary, 'rule-breaking' evening look.",
      },
    ],
  },
  {
    id: "m8",
    title: "Purple Royalty",
    price: "$80",
    defaultImage: purple1,
    allImages: [purple1, purple2, purple3, purple4],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Designed for a comfortable and flattering fit, crafted from high-quality fabric for all-day ease and effortless style. Since we have multiple fabric option, please contact us for more details.",
      },
      {
        title: "Description",
        description:
          "Rich purple hues that embody royalty and sophistication. This kurta set combines comfort with regal elegance for a truly majestic appearance.",
      },
    ],
  },
  {
    id: "m9",
    title: "Red Printed Kurta",
    price: "$75",
    defaultImage: redPrintedKurta1,
    allImages: [
      redPrintedKurta1,
      redPrintedKurta2,
      redPrintedKurta3,
      redPrintedKurta4,
      redPrintedKurta5,
    ],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "L", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Crafted from premium art silk, the fabric offers a subtle, luxurious sheen that catches the light beautifully while remaining breathable and comfortable for long hours of wear. A classic straight-cut silhouette with a formal mandarin collar and a clean button placket, providing a sharp, tailored look that flatters various body types.",
      },
      {
        title: "Description",
        description:
          "This red printed kurta is a perfect blend of traditional craftsmanship and modern elegance, making it a standout choice for any festive occasion or wedding celebration. The kurta features an intricate, all-over Ajrakh-inspired digital print. It showcases a rich tapestry of geometric motifs and floral mandalas in a sophisticated palette of crimson red, rustic orange, and deep indigo accents. Pair it with white or off-white churidar bottoms and dark brown leather mojuris (as shown) to let the bold patterns of the kurta take center stage. A celebration of heritage in every thread. This kurta isn't just an outfit; it's a statement of refined taste and cultural pride.",
      },
    ],
  },
  {
    id: "m10",
    title: "Divine Essence",
    price: "$88",
    defaultImage: Divine1,
    allImages: [Divine1, Divine2, Divine3],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["XS", "S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "Crafted from premium raw silk (Tussar blend), the fabric features a distinct slub texture that provides a rich, organic feel and a soft natural sheen. A classic long-sleeve straight-cut kurta paired with traditional white dhotis, creating a timeless and dignified ethnic silhouette.",
      },
      {
        title: "Description",
        description:
          "The standout feature is a breathtaking, hand-painted mural on the back, depicting Lord Shiva and Goddess Parvati in a vibrant, watercolor-inspired style. The front placket is adorned with genuine Rudraksha beads, serving as both a functional closure and a symbolic spiritual element. The chest features an intricate antique-finish metallic brooch, adding a layer of regal sophistication. This ensemble is ideal for religious ceremonies, traditional weddings, or cultural festivals where a meaningful and artistic statement is desired. Where spirituality meets sartorial elegance. This is more than a garment; it is a canvas of tradition and faith.",
      },
    ],
  },
  {
    id: "m11",
    title: "Blush Harmony",
    price: "$78",
    defaultImage: Blush1,
    allImages: [Blush1, Blush2, Blus3],
    sizes: ["XS", "S", "M", "L", "XL", "XXL", "XXXL"],
    availableSizes: ["S", "M", "XL"],
    moreInfo: [
      {
        title: "Fit & Fabric",
        description:
          "The base is a high-quality tussar silk blend in a soft blush peach, providing a structured yet comfortable fit. The sequins are densely embroidered to ensure a premium, multi-dimensional texture. Tailored slim-fit trousers in the same peach hue for a seamless, monochromatic look.",
      },
      {
        title: "Description",
        description:
          "The jacket features an intricate chevron and vertical stripe pattern made of shimmering rose-gold and peach sequins. The geometric alignment creates a visually lengthening effect and a dynamic play of light. A bandhgala-style open jacket with a clean mandarin collar over a matching knee-length silk kurta that maintains tonal consistency. The ensemble is elevated by a contrasting cream and ruby-red floral Jamawar shawl, adding a touch of traditional heritage. Paired with ivory embroidered Jutis, pulling the ivory accents from the shawl together. An ideal choice for daytime weddings, engagement ceremonies, or premium festive gatherings. A sophisticated fusion of rose-gold glamour and traditional roots. Designed for the man who wants to shine without losing his edge.",
      },
    ],
  },
];
